
import Vue from 'vue'
import escape from 'lodash/escape'
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate'
import { required, email, min, max } from 'vee-validate/dist/rules'
import ja from 'vee-validate/dist/locale/ja.json'

import FormCard from '~/components/atoms/Card.vue'
import Button from '~/components/atoms/Button.vue'
import InputBox from '~/components/molecules/InputBox.vue'
import Separator from '~/components/atoms/Separator.vue'
import Alert from '~/components/atoms/Alert.vue'
import AuthContainer from '~/components/organisms/AuthContainer.vue'
import Information from '~/components/atoms/Information.vue'
import AuthServiceList from '~/components/organisms/AuthServiceList.vue'

import { password } from '~/validator/password'
import { AuthApiUrl, DiagnosisApiUrl } from '~/server/api/route/url'
import loginRedirect from '~/middleware/loginRedirect'

interface LoginForm {
  email: string
  password: string
  fromUserId: string
}

interface DataTypes {
  error: any
  loginForm: LoginForm
}

localize('ja', ja)

extend('email', {
  ...email,
})
extend('required', {
  ...required,
})

extend('password', {
  ...password,
})
extend('min', {
  ...min,
})
extend('max', {
  ...max,
})
export default Vue.extend({
  components: {
    FormCard,
    Button,
    InputBox,
    Separator,
    Alert,
    ValidationProvider,
    ValidationObserver,
    AuthContainer,
    Information,
    AuthServiceList,
  },
  layout: 'public',
  middleware: [loginRedirect],
  data(): DataTypes {
    return {
      error: null,
      loginForm: {
        email: '',
        password: '',
        fromUserId: escape(this.$route.params.fromUserId as string) || '',
      },
    }
  },
  methods: {
    async login() {
      try {
        const loginForm = this.$data.loginForm
        await this.$axios.$post(AuthApiUrl.LOGIN, loginForm)
      } catch (e) {
        this.$data.error = 'ログインできませんでした'
        return
      }

      let linkURL = '/discover_sexualities/users/mypage'
      const diagnoses = await this.$axios.$get(DiagnosisApiUrl.INDEX)
      if (diagnoses.length === 0) {
        const diagnosisID = await this.$axios.$post(DiagnosisApiUrl.CREATE)
        linkURL = `/discover_sexualities/users/question/${diagnosisID}`
      }

      window.location.href = linkURL
    },
  },
})
